import apiMeterClient from './apiMeterClient'

const END_POINT = '/clients'

const get = (gateway) => 
    apiMeterClient.get( `${END_POINT}/${gateway.id}?key=${gateway.key}` )

const setActive = (gateway, status) => 
    apiMeterClient.post( `${END_POINT}/activation/${gateway.id}?key=${gateway.key}`, {
        active: status
    })

const getStatus = (gateways) => 
    apiMeterClient.get( `${END_POINT}/status?gateways=${gateways.toString()}` )

const Gateway = { get, setActive, getStatus }

export default Gateway